import React, { useEffect, useState } from "react";
import Layout from "../../../../components/layouts/Layout";
import DataTable from "react-data-table-component";
import * as XLSX from "xlsx";
// import "react-toastify/dist/ReactToastify.css";
import ProgressComponent from "../../../../components/general/ProgressComponent";
import { GET_STAFF_ABSENCE_REPORT } from "../../../../env";
import Dropdown from 'react-bootstrap/Dropdown';
// BlobProvider, Canvas, Circle, ClipPath, Defs, Document, Ellipse, Font, G, Image, Line, LinearGradient, Link, Note, PDFDownloadLink, PDFViewer, Page, Path, Polygon, Polyline, RadialGradient, Rect, Stop, StyleSheet, Svg, Text, TextInstance, Tspan, View, createRenderer, default, pdf, render, renderToBuffer, renderToFile, renderToStream, renderToString, usePDF, version
import { Document, Page, Text, View, StyleSheet, PDFDownloadLink, Line } from '@react-pdf/renderer';
import { PDFViewer } from '@react-pdf/renderer';
import DatePicker from "react-datepicker";
import {
    getRecords,
    isSuccess,
    filterColumns,
    catchAsync,
} from "../../../../helper/helper";
import moment from "moment";
import Input from "../../../../components/forms-fields/Input";

function StaffAbsenceSummaryReport() {

    const [filteredRows, setFilteredRows] = useState([]);
    console.log("🚀 ~ StaffAbsenceSummaryReport ~ filteredRows:", filteredRows)
    const [isLoading, setIsLoading] = useState(true);
    const [hldRqStartDate, setHldRqStartDate] = useState(moment().startOf('month').valueOf());
    const [hldRqEndDate, setHldRqEndDate] = useState(moment().endOf('month').valueOf());
    const [apiQuery, setApiQuery] = useState({
        startDate: hldRqStartDate,
        endDate: hldRqEndDate,
    });
    useEffect(() => {
        setApiQuery({
            startDate: moment(hldRqStartDate).valueOf(),
            endDate: moment(hldRqEndDate).valueOf()
        });
    }, [hldRqStartDate, hldRqEndDate]);
    // console.log("🚀 ~ StaffAbsenceSummaryReport ~ apiQuery:", apiQuery)

    useEffect(() => {
        fetchAllRecords({
            startDate: moment(hldRqStartDate).valueOf(),
            endDate: moment(hldRqEndDate).valueOf(),
        });
    }, [hldRqStartDate, hldRqEndDate]);

    const processFetchRecords = (method, data) => {
        if (data?.status !== isSuccess) {
        } else if (method === "get" && data?.status === isSuccess) {
            const staffMembers = data?.data
            setFilteredRows(staffMembers);
            setIsLoading(false);
        }
    };

    const fetchAllRecords = catchAsync(async (query) => {
        // debugger
        const response = await getRecords(GET_STAFF_ABSENCE_REPORT, query);
        console.log("🚀 ~ fetchAllRecords ~ response:", response)

        processFetchRecords("get", response);
    });

    useEffect(() => {
        fetchAllRecords();
    }, []);

    const columns = [
        {
            name: "#",
            selector: (row, index) => (
                <span >
                    {index + 1}
                </span>
            ),
            width: "5%",
            center: true,
        },
        {
            name: "Name",
            selector: (row) => {
                return (
                    <div
                        className="usersNameInfo py-2"
                    >
                        <span className="userInfo">
                            <span className="nameBlock">
                                {`${row?.staffRequester?.modelId?.staffMemberName && row?.staffRequester?.modelId?.staffMemberName}`}
                                {" "}
                                {`${row?.staffRequester?.modelId?.lastName !== null && row?.staffRequester?.modelId?.lastName !== undefined ? row?.staffRequester?.modelId?.lastName : ""}`}
                            </span>
                        </span>
                    </div>
                );
            },
            width: "20%"
        },
        {
            name: "Job Title",
            selector: (row) => {
                return (
                    <span >
                        {row?.staffRequester?.modelId?.jobTitle ? row?.staffRequester?.modelId?.jobTitle : "-"}
                    </span>
                );
            },
            wrap: true,
            center: true
        },
        {
            name: "Managers Name",
            selector: (row) => {
                return (
                    <div
                        className="usersNameInfo py-2"
                    >
                        <span className="userInfo">
                            <span className="nameBlock">
                                {`${row?.staffRequester?.modelId?.managerId?.modelId?.staffMemberName && row?.staffRequester?.modelId?.managerId?.modelId?.staffMemberName}`}
                                {" "}
                                {`${row?.staffRequester?.modelId?.managerId?.modelId?.lastName !== null && row?.staffRequester?.modelId?.managerId?.modelId?.lastName !== undefined ? row?.staffRequester?.modelId?.managerId?.modelId?.lastName : ""}`}
                            </span>
                        </span>
                    </div>
                );
            },
            wrap: true,
            center: true
        },
        {
            name: "Absence Start",
            selector: (row) => {
                return (
                    <span >
                        {moment(row?.hldRqStartDate).format("DD-MM-YYYY")}
                    </span>
                );
            },
            wrap: true,
            center: true
        },
        {
            name: "Absence End",
            selector: (row) => {
                return (
                    <span >
                        {moment(row?.hldRqEndDate).format("DD-MM-YYYY")}
                    </span>
                );
            },
            wrap: true,
            center: true
        },
        {
            name: "NoDays",
            selector: (row) => {
                return (
                    <span className="text-capitalize">
                        {row?.hldRqTotalDays}
                    </span>
                );
            },
            wrap: true,
            center: true
        },
    ];

    const filteredColumns = filterColumns(columns, (column) => column !== null);


    // Export Data
    const styles = StyleSheet.create({
        pages: {
            padding: "10px",
        },
        sectionTitle: {
            fontSize: "16px",
            fontWeight: "black",
            marginBottom: "5px",
            textAlign: "center",
            padding: "10px",
            backgroundColor: "#f0f0f0"
        },
        sectionSubTitle: {
            fontSize: "14px",
            fontWeight: "black",
            marginBottom: "5px",
            textAlign: "center",
            padding: "10px",
            backgroundColor: "#f0f0f0"
        },
        section: {
            margin: 10,
            padding: 10,
            flexGrow: 1,
        },
        tableHead: {
            flexDirection: "row",
            justifyContent: "space-between",
            backgroundColor: "#f0f0f0",
            padding: "10px 10px",
            marginBottom: "5px",
            fontSize: "10px",
            fontWeight: "bold",
            wordWrap: "break-word",
        },
        tabBody: {
            flexDirection: "row",
            justifyContent: "space-between",
            padding: "10px 10px",
            borderBottom: "1px solid #ccc",
            fontSize: "10px",
            wordWrap: "break-word",
        },
        wordwrap: {
            flexBasis: "50%",
            wordWrap: "break-word",
        },
    });

    const MyDocument = (start) => (
        <Document>
            <Page size="A4" orientation="landscape" style={styles.pages}>
                <View>
                    <Text style={styles.sectionTitle}>Staff Absence Summary Report {moment(hldRqStartDate).format("DD/MM/YYYY")} - {moment(hldRqEndDate).format("DD/MM/YYYY")}</Text>
                    <View style={styles.tableHead}>
                        <Text style={{ width: "25%" }}>Name</Text>
                        <Text style={{ width: "15%" }}>Job Title</Text>
                        <Text style={{ width: "15%" }}>Managers Name</Text>
                        <Text style={{ width: "15%" }}>AbsenceS tart</Text>
                        <Text style={{ width: "15%" }}>Absence End</Text>
                        <Text style={{ width: "15%" }}>No Days</Text>
                    </View>
                    {filteredRows.map((row, index) => (
                        <View key={index} style={styles.tabBody}>
                            <Text style={{ width: "25%" }}>
                                {`${row?.staffRequester?.modelId?.staffMemberName && row?.staffRequester?.modelId?.staffMemberName}`}
                                {" "}
                                {`${row?.staffRequester?.modelId?.lastName !== null && row?.staffRequester?.modelId?.lastName !== undefined ? row?.staffRequester?.modelId?.lastName : ""}`}
                            </Text>
                            <Text style={{ width: "15%" }}>{row?.staffRequester?.modelId?.jobTitle ? row?.staffRequester?.modelId?.jobTitle : "-"}</Text>
                            <Text style={{ width: "15%" }}>
                                {`${row?.staffRequester?.modelId?.managerId?.modelId?.staffMemberName && row?.staffRequester?.modelId?.managerId?.modelId?.staffMemberName}`}
                                {" "}
                                {`${row?.staffRequester?.modelId?.managerId?.modelId?.lastName !== null && row?.staffRequester?.modelId?.managerId?.modelId?.lastName !== undefined ? row?.staffRequester?.modelId?.managerId?.modelId?.lastName : ""}`}
                            </Text>
                            <Text style={{ width: "15%" }}> {moment(row?.hldRqStartDate).format("DD-MM-YYYY")}</Text>
                            <Text style={{ width: "15%" }}> {moment(row?.hldRqEndDate).format("DD-MM-YYYY")}</Text>
                            <Text style={{ width: "15%" }}>{row?.hldRqTotalDays}</Text>
                        </View>
                    ))}
                </View>
            </Page>
        </Document>
    );

    const ExportButton = ({ data, data2, patientName, removeMoreColumns }) => {
        const handleExport = () => {
            // Preprocess data to format dates before exporting
            const formattedData = data.map(
                ({
                    ...item
                }) => {

                    const StaffMember =
                        `${item?.staffRequester?.modelId?.staffMemberName || ""} ` +
                        `${item?.staffRequester?.modelId?.lastName || ""}`;

                    const JobTitle = item?.staffRequester?.modelId?.jobTitle;
                    const ManagersName =
                        `${item?.staffRequester?.modelId?.managerId?.modelId?.staffMemberName || ""} ` +
                        `${item?.staffRequester?.modelId?.managerId?.modelId?.lastName || ""}`;
                    const AbsenceStart = moment(item?.hldRqStartDate).format("DD-MM-YYYY");
                    const AbsenceEnd = moment(item?.hldRqEndDate).format("DD-MM-YYYY");
                    const NoDays = item?.hldRqTotalDays;


                    removeMoreColumns.forEach((column) => {
                        delete item[column];
                    });

                    return {
                        ...item,
                        StaffMember: StaffMember,
                        JobTitle: JobTitle,
                        ManagersName: ManagersName,
                        AbsenceStart: AbsenceStart,
                        AbsenceEnd: AbsenceEnd,
                        NoDays: NoDays,
                    };
                }
            );

            const formattedData2 = [{ "Staff Absence Summary Report": patientName }];

            const fileType =
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
            const fileExtension = ".xlsx";
            const fileName = patientName;

            // Convert dataWithTitles array to worksheet
            let ws = XLSX.utils.json_to_sheet(formattedData2);

            // Add second data set to existing worksheet
            const ws2 = XLSX.utils.json_to_sheet(formattedData, {
                header: Object.keys(formattedData[0]),
                skipHeader: true,
            });

            XLSX.utils.sheet_add_json(ws, formattedData, {
                header: Object.keys(formattedData[0]),
                skipHeader: false,
                origin: -1,
            });

            // Create workbook
            const wb = { Sheets: { data: ws }, SheetNames: ["data"] };

            // Write workbook to array buffer
            const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });

            // Convert array buffer to Blob
            const blob = new Blob([excelBuffer], { type: fileType });

            // Create download link and trigger download
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = fileName + fileExtension;
            a.click();
        };

        return <span onClick={handleExport}>Export as xlsx</span>;
    };

    return (
        <>

            <Layout pageTitleText="Staff Absence Summary Report">
                <header className="headerContainerSearchAction staffHolidayRequests">
                    <div className="dateInput">
                        <div className="dateBlock">
                            <div className={`form-group`}>
                                <DatePicker
                                    selected={new Date(hldRqStartDate)} // Pass a Date object
                                    dateFormat="dd/MM/yyyy"
                                    onChange={(date) => {
                                        if (date) setHldRqStartDate(moment(date).valueOf()); // convert to timestamp
                                    }}
                                    className="datePicker"
                                    isClearable={false}
                                />
                            </div>
                            <div className={`form-group`}>
                                <DatePicker
                                    selected={new Date(hldRqEndDate)} // Pass a Date object
                                    dateFormat="dd/MM/yyyy"
                                    onChange={(date) => {
                                        if (date) setHldRqEndDate(moment(date).valueOf()); // convert to timestamp
                                    }}
                                    className="datePicker"
                                    isClearable={false}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="actionButtons">
                        <div className="gap-1">
                            <a className="btn btn-sm btn-primary" href="/reports">
                                Back to Reports
                            </a>
                            <>
                                {
                                    filteredRows.length > 0 && (
                                        <Dropdown>
                                            <Dropdown.Toggle variant="outline-success" size="sm" id="dropdown-basic">
                                                Export Data
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu className="exportDataList">
                                                <>
                                                    <span className="">
                                                        <PDFDownloadLink document={<MyDocument columns={columns} data={filteredColumns} />} fileName={"Staff Absence Summary Report" + " " + moment(hldRqStartDate).format("DD/MM/YYYY") + " - " + moment(hldRqEndDate).format("DD/MM/YYYY")}>
                                                            {({ loading }) =>
                                                                loading ? '...' : 'Export as PDF'
                                                            }
                                                        </PDFDownloadLink>
                                                    </span>
                                                    <span className="">
                                                        <ExportButton data={filteredRows} patientName={"Staff Absence Summary Report" + " " + moment(hldRqStartDate).format("DD/MM/YYYY") + " - " + moment(hldRqEndDate).format("DD/MM/YYYY")} removeMoreColumns={["_id", "staffRequester", "hldRqStartDate", "hldRqEndDate", "hldRqTotalDays", "hldRqTotalHours", "hldRqStatus", "hldRqApproved", "hldRqReason", "hldRequestType", "addedby", "active", "createdAt", "updatedAt", "__v"]} />
                                                    </span>
                                                </>

                                            </Dropdown.Menu>
                                        </Dropdown>
                                    )
                                }
                            </>
                        </div>
                    </div>
                </header>
                {/* <PDFViewer style={{ width: "100%", height: "300px" }}>
                    <MyDocument />
                </PDFViewer> */}

                <div className="mainContent h-100 noCursorPointer">
                    <div className="dataTableWrapper staffRecordsGroupsTable minHeight300">
                        <DataTable
                            className="maxWidthTable"
                            columns={filteredColumns}
                            data={filteredRows}
                            fixedHeader
                            fixedHeaderScrollHeight="520px"
                            highlightOnHover
                            responsive={true}
                            subHeaderWrapperProps={{ style: { padding: 0, margin: 0 } }}
                            progressPending={isLoading}
                            progressComponent={<ProgressComponent />}
                        />
                    </div>
                </div>
            </Layout >
        </>
    );
}

export default StaffAbsenceSummaryReport;
